import React from 'react';
import ProgressDot from '../../shared/ProgressDot';
import { formatNumber } from '../../shared/numberFormat';

// The Ship confirmation's line summary (issue #205), built by
// ShipConfirmFields.js from the package being shipped (issue #299) as
// { key, sku, name, qty, shippable, backorder, outcome, noneText? } rows, so
// the summary itself, and its wording, only exists in one place.
// Same shared/ProgressDot.js the Sales Orders list's own Fulfilment
// Progress Circle uses (see ui-architecture.md) — full/partial/none, just
// per-line here instead of per-order.
const OUTCOME_STATE = { full: 'full', partial: 'partial', none: 'empty' };

function ShipConfirmSummary({ rows }) {
  const shippingCount = rows.filter((r) => r.outcome !== 'none').length;
  const backorderCount = rows.filter((r) => r.backorder > 0).length;

  return (
    <div>
      <div style={{ fontSize: 13, color: '#555', marginBottom: 12 }}>
        {shippingCount} of {rows.length} SKU{rows.length === 1 ? '' : 's'} will ship.
        {backorderCount > 0 && ` ${backorderCount} SKU${backorderCount === 1 ? '' : 's'} will be backordered.`}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {rows.map((r) => (
          <div key={r.key} style={{ display: 'flex', alignItems: 'baseline', gap: 8, fontSize: 13, padding: '6px 10px', borderRadius: 6, background: '#f6f8fa' }}>
            <ProgressDot state={OUTCOME_STATE[r.outcome]} />
            <span style={{ fontWeight: 600, minWidth: 90 }}>{r.sku}</span>
            <span style={{ color: '#666', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.name}</span>
            <span style={{ color: '#333', whiteSpace: 'nowrap' }}>
              {r.outcome === 'none'
                ? (r.noneText || 'Nothing packed to ship')
                : `${formatNumber(r.shippable, { maxDecimals: 4 })} of ${formatNumber(r.qty, { maxDecimals: 4 })} will ship${r.backorder > 0 ? ` — ${formatNumber(r.backorder, { maxDecimals: 4 })} backordered` : ''}`}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ShipConfirmSummary;
